import {attachmentPresignAPI} from "@/app/apiPaths";
import {
  AttachmentPresignRequest,
  AttachmentPresignResponse,
} from "@/pb/api/devplan/services/web/company";

/**
 * Signs an attachment upload request via the presign API.
 * Supports both document and image attachments.
 * Returns the attachment ID and signed URL for direct upload.
 */
export async function signAttachment(
  companyId: number,
  extension: string,
  fileType: string,
  fileName: string,
  fileSize: number,
  userDescription?: string,
): Promise<{fullPath: string; signedUrl: string}> {
  const resp = await fetch(attachmentPresignAPI(companyId), {
    method: "POST",
    headers: {"Content-Type": "application/json"},
    body: JSON.stringify(
      AttachmentPresignRequest.create({
        fileExtension: extension,
        fileType,
        fileSize,
        originalFileName: fileName,
        userDescription: userDescription || undefined,
      })
    ),
  });
  if (!resp.ok) {
    const err = await resp.json().catch(() => ({error: "Presign failed"}));
    throw new Error(err.error || "Presign failed");
  }
  const data = AttachmentPresignResponse.fromJSON(await resp.json());
  return {fullPath: data.attachmentId, signedUrl: data.signedUrl};
}

